var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "78.0019037px",
    height: "67px",
    viewBox: "0 0 78.0019037 67",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Empty Cart") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "v3---product-campaign-1j---success",
    transform: "translate(-1007.000000, -4512.000000)",
    stroke: "#231F20",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(0.000000, 1640.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4-Copy",
    transform: "translate(841.000000, 2873.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(167.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,0 L15.0742079,0 L30.9110744,42.57242 C32.5744205,47.6974934 35.7997048,50 39.5796504,50 L76,50 L6,0 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "20 10 76 10 70.8183753 39 29.8839651 39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,60 C48,57.2386224 45.7614694,55 43.000205,55 C40.2383256,55 38,57.2386224 38,60 C38,62.7613776 40.2383256,65 43.000205,65 C45.7614694,65 48,62.7613776 48,60 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72,60 C72,57.2386224 69.7613776,55 67,55 C64.2386224,55 62,57.2386224 62,60 C62,62.7613776 64.2386224,65 67,65 C69.7613776,65 72,62.7613776 72,60 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,17 L14,17 L0,17 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,33 L17,33 L7,33 Z",
    id: "Path"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCart);
export default __webpack_public_path__ + "static/media/EmptyCart.9594646460392fea25cf27b58e678147.svg";
export { ForwardRef as ReactComponent };